import React, { useState, useEffect } from "react";
import { Box, Typography, Paper, Collapse } from "@mui/material";
import DEMO_CONFIG from "../config/demo";

/**
 * Demo Mode Toggle Component
 *
 * This component displays the current demo mode status.
 * Note: To actually toggle demo mode, you need to edit src/config/demo.js
 * and restart the application.
 */
const DemoModeIndicator = () => {
  const [isExpanded, setIsExpanded] = useState(true);

  useEffect(() => {
    // Auto-collapse after 5 seconds
    const timer = setTimeout(() => {
      setIsExpanded(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  if (!DEMO_CONFIG.USE_MOCK_API) {
    // Don't show indicator when using real API
    return null;
  }

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Paper
      elevation={3}
      onClick={handleToggle}
      sx={{
        position: "fixed",
        bottom: 20,
        right: 20,
        backgroundColor: "#ff9800",
        color: "white",
        zIndex: 9999,
        borderRadius: "8px",
        overflow: "hidden",
        transition: "all 0.3s ease",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "#f57c00",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Box
          sx={{
            color: "white",
            padding: "10px 12px",
            borderRadius: isExpanded ? "8px 0 0 8px" : "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h6">🎭</Typography>
        </Box>
        <Collapse in={isExpanded} orientation="horizontal">
          <Box
            sx={{
              padding: "10px 20px 10px 0",
              display: "flex",
              alignItems: "center",
              gap: 1,
              whiteSpace: "nowrap",
            }}
          >
            <Typography variant="body2" fontWeight="bold">
              DEMO MODE ACTIVE
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.9 }}>
              Using mock data
            </Typography>
          </Box>
        </Collapse>
      </Box>
    </Paper>
  );
};

export default DemoModeIndicator;
